module.exports = __webpack_public_path__ + "img/home_banner_card.cb9fafdc.png";